const prefix = '/apartment';

export const routes = {
  APARTMENT: prefix,
  LIST: `${prefix}/list`,
  CONTRACT: `${prefix}/contract`,
};
